export default __webpack_public_path__ + "static/media/img_baseBunny_rose_p.b65dec46.jpg";